// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-home {
    display: flex;
    flex-direction: column;
    min-height: 700px; /* Set the minimum height of the entire app */
}

.main-content {
    min-height: 500px;
}


/* .info-table {
  border-collapse: collapse;
  width: 100%; 
}

.info-table, .tableHeader, .tableRow {
  border: 1px solid black;
} */

.info-content {
    font-size: 0.9rem;

    /* .show-more-button {
        background: none;
        border: none;
        color: blue;
        cursor: pointer;
        padding: 0;
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    } */
}
`, "",{"version":3,"sources":["webpack://./src/features/common/WtyReportHome.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB,EAAE,6CAA6C;AACpE;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;;;;;;;GAOG;;AAEH;IACI,iBAAiB;;IAEjB;;;;;;;;;;;OAWG;AACP","sourcesContent":[".app-home {\n    display: flex;\n    flex-direction: column;\n    min-height: 700px; /* Set the minimum height of the entire app */\n}\n\n.main-content {\n    min-height: 500px;\n}\n\n\n/* .info-table {\n  border-collapse: collapse;\n  width: 100%; \n}\n\n.info-table, .tableHeader, .tableRow {\n  border: 1px solid black;\n} */\n\n.info-content {\n    font-size: 0.9rem;\n\n    /* .show-more-button {\n        background: none;\n        border: none;\n        color: blue;\n        cursor: pointer;\n        padding: 0;\n        text-decoration: underline;\n\n        &:hover {\n            text-decoration: none;\n        }\n    } */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
